import script from "./CardBoxSiswa.vue?vue&type=script&setup=true&lang=js"
export * from "./CardBoxSiswa.vue?vue&type=script&setup=true&lang=js"

import "./CardBoxSiswa.vue?vue&type=style&index=0&id=5e349b7a&scoped=true&lang=css"

import exportComponent from "/var/www/html/amatra-frontend-dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5e349b7a"]])

export default __exports__